import { Droppable } from '../../../utils'

import {
    ConnectwareError,
    type CybusDeviatedService,
    type CybusResourceDeviation,
    type CybusServiceDeviation,
    type ServicesAppState,
    type SortableColumn,
} from '../../../domain'

import { ResourcePageSubscriptionUsecase, Usecase } from '..'

export class ManageResolvedDeviationsUsecase extends Usecase {
    private setServiceDeviationResolution (serviceDeviationResolution: ServicesAppState['serviceDeviationResolution']): void {
        this.setState({ serviceDeviationResolution })
    }

    subscribe (): VoidFunction {
        const droppable = new Droppable()

        this.subscriptionsService
            .subscribeToAll('resolvedServiceDeviations', (event) => {
                if (ConnectwareError.is(event)) {
                    this.logger.error(event)
                } else {
                    this.setServiceDeviationResolution(event)
                }
            })
            .then((off) => {
                droppable.onDrop(off)

                /** Reset state */
                droppable.onDrop(() => this.setServiceDeviationResolution(null))
            })
            .catch((e: ConnectwareError) => {
                this.logger.error(e)
                droppable.drop()
            })

        return () => droppable.drop()
    }
}

export class ManageServicesDeviationsUsecase extends ResourcePageSubscriptionUsecase<'serviceDeviations'> {
    protected readonly pageName = 'serviceDeviations'

    protected readonly pageAddress = 'serviceDeviationsPage'

    protected readonly initialSortColumn: SortableColumn<CybusServiceDeviation> = 'id'
}

export class ManageResourcesDeviationsUsecase extends ResourcePageSubscriptionUsecase<'resourceDeviation'> {
    protected readonly pageName = 'resourceDeviation'

    protected readonly pageAddress = 'resourceDeviationPage'

    protected readonly initialSortColumn: SortableColumn<CybusResourceDeviation> = 'resourceId'
}

export class ManageDeviatedServicesUsecase extends ResourcePageSubscriptionUsecase<'deviatedServices'> {
    protected readonly pageName = 'deviatedServices'

    protected readonly pageAddress = 'deviatedServicesPage'

    protected readonly initialSortColumn: SortableColumn<CybusDeviatedService> = 'id'
}
